import { Tabs } from 'antd';
import i18next from 'i18next';
import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router';
import {
  CONTACT_TABS_KEY_VALUE,
  TABS_KEY_VALUE,
} from 'configs/localData/constant';
import ParentProfile from '../components/ParentProfile';

const { TabPane } = Tabs;

const ContactDetailTabs = () => {
  const { push } = useHistory();
  const { id, modelDetail } = useParams();

  const TABS = [
    {
      key: CONTACT_TABS_KEY_VALUE.parentProfile,
      title: 'contacts.tabs.parentProfile',
      TabComponent: ParentProfile,
    },
  ];

  const onChange = useCallback(
    (key) => {
      push(`/contacts/${id}/${key}`);
    },
    [push, id],
  );

  return (
    <div>
      <Tabs
        activeKey={modelDetail || TABS_KEY_VALUE.summary}
        onChange={onChange}
      >
        {TABS.map(({ title, key, TabComponent, ...tab }) => (
          <TabPane tab={i18next.t(title)} key={key}>
            <TabComponent {...tab} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default ContactDetailTabs;
